import { useLocation, useParams, Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { useLocalePath } from '@/hooks/useLocalePath';
import { Price } from '@/components/Price';
import { Seo } from '@/components/Seo';
import type { JSX } from 'react';

export function OrderConfirmationPage(): JSX.Element {
  const { t } = useTranslation();
  const path = useLocalePath();
  const { number = '' } = useParams();
  const state = useLocation().state as
    | { totalGross: number; invoiceNumber: string | null; supplierOrderNumbers: string[] }
    | null;

  return (
    <>
      <Seo title={t('orderConfirmation.title')} path={`/zamowienie/${number}`} noindex />
      <div className="rz-shell max-w-xl py-24 space-y-6" data-testid="order-confirmation">
        <p className="rz-eyebrow">{t('orderConfirmation.number')}</p>
        <h1 className="text-xl md:text-2xl">{t('orderConfirmation.title')}</h1>
        <p className="font-display text-lg text-[var(--color-brand)]" data-testid="order-number">{number}</p>

        {state && (
          <dl className="space-y-1.5 border-t border-[var(--color-line)] pt-4 text-sm">
            <div className="flex justify-between">
              <dt className="text-[var(--color-muted)]">{t('cart.total')}</dt>
              <dd className="font-semibold"><Price minor={state.totalGross} /></dd>
            </div>
            {state.invoiceNumber && (
              <div className="flex justify-between">
                <dt className="text-[var(--color-muted)]">{t('orderConfirmation.invoiceReady', { number: state.invoiceNumber })}</dt>
              </div>
            )}
          </dl>
        )}

        <div className="space-y-2">
          <h2 className="rz-eyebrow">{t('orderConfirmation.whatNext')}</h2>
          <p className="text-sm leading-relaxed text-[var(--color-ink-soft)]">{t('orderConfirmation.whatNextBody')}</p>
        </div>

        <p className="text-2xs text-[var(--color-muted)] leading-relaxed">{t('email.orderConfirmation.withdrawalNote')}</p>

        <div className="flex gap-3 pt-2">
          <Link to={path('/konto')} className="rz-button">{t('account.orders')}</Link>
          <Link to={path('/')} className="rz-button rz-button--ghost">{t('cart.continueShopping')}</Link>
        </div>
      </div>
    </>
  );
}
